import { useQuery } from '@tanstack/react-query';
import { getCreditLimitWindowsApi } from '@/api/credits/credits.api';
import { useIsFigmaEmbedMode } from '@/contexts/FigmaEmbedModeContext';

export const CREDIT_LIMIT_WINDOWS_QUERY_KEY = ['credit-limit-windows'];

/**
 * The current user's per-window EAP credit-limit status, used to preemptively
 * block runs + show the out-of-credits banner. Only fetched in Figma-embed mode
 * (the windows are embed-scoped). Invalidate `CREDIT_LIMIT_WINDOWS_QUERY_KEY`
 * after a run so the freshly-consumed usage is reflected.
 */
export const useCreditLimitWindows = () => {
  const isFigmaEmbedMode = useIsFigmaEmbedMode();
  return useQuery({
    queryKey: CREDIT_LIMIT_WINDOWS_QUERY_KEY,
    queryFn: getCreditLimitWindowsApi,
    enabled: isFigmaEmbedMode,
    staleTime: 30_000,
  });
};
